module.exports = __webpack_public_path__ + "ay.no2.ad63cd5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ay.no2.jpg
// module id = kQnP
// module chunks = 0